var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var _epoch, _controller, _requests, _rendering, _filterPending, _failed, _aspectRatioHelper, _PaginatedList_instances, reset_fn, _handleFilterUpdate, active_fn, context_fn, current_fn, start_fn, observe_fn, page_fn, items_fn, prefetch_fn, fetch_fn, showFallback_fn, load_fn;
import { Component } from "@theme/component";
import { sectionRenderer } from "@theme/section-renderer";
import { requestIdleCallback, viewTransition, yieldToMainThread } from "@theme/utilities";
import { PaginatedListAspectRatioHelper } from "@theme/paginated-list-aspect-ratio";
import { StandardEvents } from "@shopify/events";
import { getScrollTop, scrollTo } from "@theme/scroll-container";
class PaginatedList extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PaginatedList_instances);
    __publicField(this, "pages", /* @__PURE__ */ new Map());
    __publicField(this, "infinityScrollObserver");
    __privateAdd(this, _epoch, 0);
    __privateAdd(this, _controller, new AbortController());
    __privateAdd(this, _requests, /* @__PURE__ */ new Map());
    __privateAdd(this, _rendering, null);
    __privateAdd(this, _filterPending, false);
    __privateAdd(this, _failed, false);
    __privateAdd(this, _aspectRatioHelper);
    __privateAdd(this, _handleFilterUpdate, (event) => {
      var _a;
      const section = (_a = event.target) == null ? void 0 : _a.closest('[id^="shopify-section-"]');
      if (section && section.id !== "shopify-section-".concat(this.sectionId)) return;
      __privateMethod(this, _PaginatedList_instances, reset_fn).call(this);
      __privateSet(this, _filterPending, true);
      const epoch = __privateGet(this, _epoch);
      if (!event.promise || typeof event.promise.then !== "function") return;
      event.promise.then(() => {
        if (!this.isConnected || epoch !== __privateGet(this, _epoch)) return;
        this.updatedCallback();
        __privateSet(this, _filterPending, false);
        if (this.refs.paginationFallback) this.refs.paginationFallback.hidden = true;
        __privateMethod(this, _PaginatedList_instances, start_fn).call(this);
      }).catch(() => {
      });
    });
  }
  connectedCallback() {
    super.connectedCallback();
    __privateMethod(this, _PaginatedList_instances, reset_fn).call(this);
    if (this.getAttribute("infinite-scroll") === "false") return;
    const templateCard = this.querySelector('[ref="cardGallery"]');
    if (templateCard) __privateSet(this, _aspectRatioHelper, new PaginatedListAspectRatioHelper({ templateCard }));
    document.addEventListener(StandardEvents.searchUpdate, __privateGet(this, _handleFilterUpdate));
    document.addEventListener(StandardEvents.collectionUpdate, __privateGet(this, _handleFilterUpdate));
    __privateMethod(this, _PaginatedList_instances, start_fn).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateMethod(this, _PaginatedList_instances, reset_fn).call(this);
    __privateGet(this, _controller).abort();
    document.removeEventListener(StandardEvents.searchUpdate, __privateGet(this, _handleFilterUpdate));
    document.removeEventListener(StandardEvents.collectionUpdate, __privateGet(this, _handleFilterUpdate));
  }
  get sectionId() {
    const id = this.getAttribute("section-id");
    if (!id) throw new Error("The section-id attribute is required");
    return id;
  }
}
_epoch = new WeakMap();
_controller = new WeakMap();
_requests = new WeakMap();
_rendering = new WeakMap();
_filterPending = new WeakMap();
_failed = new WeakMap();
_aspectRatioHelper = new WeakMap();
_PaginatedList_instances = new WeakSet();
reset_fn = function() {
  var _a;
  __privateWrapper(this, _epoch)._++;
  __privateGet(this, _controller).abort();
  __privateSet(this, _controller, new AbortController());
  __privateGet(this, _requests).clear();
  this.pages.clear();
  __privateSet(this, _rendering, null);
  __privateSet(this, _filterPending, false);
  __privateSet(this, _failed, false);
  (_a = this.infinityScrollObserver) == null ? void 0 : _a.disconnect();
  if (this.refs.paginationFallback) this.refs.paginationFallback.hidden = true;
};
_handleFilterUpdate = new WeakMap();
active_fn = function() {
  return this.isConnected && !__privateGet(this, _filterPending) && !__privateGet(this, _failed) && this.getAttribute("infinite-scroll") !== "false";
};
context_fn = function() {
  const url = new URL(window.location.href);
  url.searchParams.delete("page");
  url.searchParams.delete("section_id");
  url.searchParams.sort();
  url.hash = "";
  return url.toString();
};
current_fn = function(epoch, context) {
  return __privateMethod(this, _PaginatedList_instances, active_fn).call(this) && epoch === __privateGet(this, _epoch) && context === __privateMethod(this, _PaginatedList_instances, context_fn).call(this);
};
start_fn = function() {
  if (!__privateMethod(this, _PaginatedList_instances, active_fn).call(this)) return;
  __privateMethod(this, _PaginatedList_instances, observe_fn).call(this);
  __privateMethod(this, _PaginatedList_instances, prefetch_fn).call(this, "next");
  __privateMethod(this, _PaginatedList_instances, prefetch_fn).call(this, "previous");
};
observe_fn = function() {
  const { viewMorePrevious, viewMoreNext } = this.refs;
  if (!viewMorePrevious && !viewMoreNext) return;
  if (!this.infinityScrollObserver) {
    this.infinityScrollObserver = new IntersectionObserver(async (entries) => {
      const epoch = __privateGet(this, _epoch);
      try {
        if (viewTransition.current) await viewTransition.current;
        if (!__privateMethod(this, _PaginatedList_instances, active_fn).call(this) || epoch !== __privateGet(this, _epoch)) return;
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          if (entry.target === this.refs.viewMorePrevious) __privateMethod(this, _PaginatedList_instances, load_fn).call(this, "previous");
          else if (entry.target === this.refs.viewMoreNext) __privateMethod(this, _PaginatedList_instances, load_fn).call(this, "next");
        }
      } catch (error) {
        if (__privateMethod(this, _PaginatedList_instances, active_fn).call(this) && epoch === __privateGet(this, _epoch)) __privateMethod(this, _PaginatedList_instances, showFallback_fn).call(this);
      }
    }, { rootMargin: "100px" });
  }
  this.infinityScrollObserver.disconnect();
  if (viewMorePrevious) this.infinityScrollObserver.observe(viewMorePrevious);
  if (viewMoreNext) this.infinityScrollObserver.observe(viewMoreNext);
};
page_fn = function(type) {
  var _a;
  const cards = this.refs.cards;
  if (!Array.isArray(cards) || !cards.length) return;
  const card = cards[type === "previous" ? 0 : cards.length - 1];
  const current = Number(card.dataset.page);
  const last = Number((_a = this.refs.grid) == null ? void 0 : _a.dataset.lastPage);
  const page = current + (type === "previous" ? -1 : 1);
  if (!Number.isInteger(current) || !Number.isInteger(last) || page < 1 || page > last) return;
  const url = new URL(window.location.href);
  url.searchParams.set("page", String(page));
  url.searchParams.delete("section_id");
  url.hash = "";
  return { page, url };
};
items_fn = function(html, page) {
  const parsed = new DOMParser().parseFromString(html, "text/html");
  const grid = parsed.querySelector('[ref="grid"]');
  if (!grid) throw new Error("Missing pagination grid");
  const items = Array.from(grid.querySelectorAll(':scope > [ref="cards[]"]'));
  if (!items.length || items.some((item) => Number(item.dataset.page) !== page)) throw new Error("Invalid pagination items");
  return items;
};
prefetch_fn = function(type) {
  const page = __privateMethod(this, _PaginatedList_instances, page_fn).call(this, type);
  if (page && __privateMethod(this, _PaginatedList_instances, active_fn).call(this)) return __privateMethod(this, _PaginatedList_instances, fetch_fn).call(this, page);
};
fetch_fn = function(page) {
  if (this.pages.has(page.page)) return Promise.resolve(this.pages.get(page.page));
  const key = page.url.toString();
  if (__privateGet(this, _requests).has(key)) return __privateGet(this, _requests).get(key);
  const epoch = __privateGet(this, _epoch), context = __privateMethod(this, _PaginatedList_instances, context_fn).call(this), controller = __privateGet(this, _controller);
  const request = (async () => {
    await Promise.resolve();
    try {
      const html = await sectionRenderer.getSectionHTML(this.sectionId, true, new URL(page.url), controller.signal);
      if (!__privateMethod(this, _PaginatedList_instances, current_fn).call(this, epoch, context)) return null;
      __privateMethod(this, _PaginatedList_instances, items_fn).call(this, html, page.page);
      this.pages.set(page.page, html);
      return html;
    } catch (error) {
      if (__privateMethod(this, _PaginatedList_instances, current_fn).call(this, epoch, context)) __privateMethod(this, _PaginatedList_instances, showFallback_fn).call(this);
      return null;
    } finally {
      if (epoch === __privateGet(this, _epoch) && __privateGet(this, _requests).get(key) === request) __privateGet(this, _requests).delete(key);
    }
  })();
  __privateGet(this, _requests).set(key, request);
  return request;
};
showFallback_fn = function() {
  var _a;
  __privateSet(this, _failed, true);
  (_a = this.infinityScrollObserver) == null ? void 0 : _a.disconnect();
  for (const type of ["previous", "next"]) {
    const link = this.refs[type === "next" ? "paginationNext" : "paginationPrevious"];
    if (!link) continue;
    const page = __privateMethod(this, _PaginatedList_instances, page_fn).call(this, type);
    link.hidden = !page;
    if (page) link.href = page.url.toString();
  }
  if (this.refs.paginationFallback) this.refs.paginationFallback.hidden = false;
};
load_fn = async function(type) {
  var _a, _b;
  if (!__privateMethod(this, _PaginatedList_instances, active_fn).call(this) || __privateGet(this, _rendering)) return;
  const grid = this.refs.grid, page = __privateMethod(this, _PaginatedList_instances, page_fn).call(this, type);
  if (!grid || !page) return;
  const epoch = __privateGet(this, _epoch), context = __privateMethod(this, _PaginatedList_instances, context_fn).call(this), token = {};
  __privateSet(this, _rendering, token);
  try {
    const html = await __privateMethod(this, _PaginatedList_instances, fetch_fn).call(this, page);
    if (!html || !__privateMethod(this, _PaginatedList_instances, current_fn).call(this, epoch, context) || this.refs.grid !== grid || ((_a = __privateMethod(this, _PaginatedList_instances, page_fn).call(this, type)) == null ? void 0 : _a.page) !== page.page) return;
    const items = __privateMethod(this, _PaginatedList_instances, items_fn).call(this, html, page.page);
    const first = grid.firstElementChild, top = getScrollTop();
    const before = first ? first.getBoundingClientRect().top + top : 0;
    if (type === "previous") grid.prepend(...items);
    else grid.append(...items);
    (_b = __privateGet(this, _aspectRatioHelper)) == null ? void 0 : _b.processNewElements();
    this.updatedCallback();
    if (type === "previous" && first) scrollTo({ top: top + first.getBoundingClientRect().top + getScrollTop() - before, behavior: "instant" });
    await yieldToMainThread();
    if (!__privateMethod(this, _PaginatedList_instances, current_fn).call(this, epoch, context) || this.refs.grid !== grid) return;
    history.pushState(history.state, "", page.url.toString());
    requestIdleCallback(() => {
      if (__privateMethod(this, _PaginatedList_instances, current_fn).call(this, epoch, context)) __privateMethod(this, _PaginatedList_instances, prefetch_fn).call(this, type);
    });
  } catch (error) {
    if (__privateMethod(this, _PaginatedList_instances, current_fn).call(this, epoch, context)) __privateMethod(this, _PaginatedList_instances, showFallback_fn).call(this);
  } finally {
    if (__privateGet(this, _rendering) === token) __privateSet(this, _rendering, null);
  }
};
var stdin_default = PaginatedList;
export {
  stdin_default as default
};
